import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_WARRANTY_REPORT = {
  'list': [],
  'loading': false,
  'fileURL': '',
  'loadingFile': false,
};

export const warrantyReport = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTY_REPORT, {
    [ActionTypes.FETCHING_WARRANTY_REPORT_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WARRANTY_REPORT_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_WARRANTY_REPORT_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.FETCHING_WARRANTY_REPORT]: (state, action) => ({
      ...state,
      'loadingFile': true,
    }),
    [ActionTypes.FETCHED_WARRANTY_REPORT]: (state, action) => ({
      ...state,
      'loadingFile': false,
      'fileURL': action.response.data,
    }),
    [ActionTypes.FETCHED_WARRANTY_REPORT_FAILED]: (state, action) => ({
      ...state,
      'loadingFile': false,
      'fileURL': '',
    }),
    [ActionTypes.CLEAR_WARRANTY_REPORT_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE_WARRANTY_REPORT,
    }),
    [ActionTypes.CLEAR_WARRANTY_REPORT]: (state, action) => ({
      ...state,
      'fileURL': '',
    }),
  })(state, action);
};
